import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import AlertBadgesType from "@app/enum/map/AlertBadgesType";

export const toggleAlertBadgeVisibility = createAction(
  "map/alertBadges/toggleAlertBadgeVisibility"
)<AlertBadgesType>();

export const setAlertDismissed = createAction("map/alertBadges/setAlertDismissed")<{
  alertDismissed: boolean;
}>();

export const enableEngagementFields = createAsyncAction(
  "map/alertBadges/enableEngagementFields/request",
  "map/alertBadges/enableEngagementFields/success",
  "map/alertBadges/enableEngagementFields/failure"
)<void, void, unknown>();

export type AlertBadgesActions = ActionType<
  typeof enableEngagementFields | typeof setAlertDismissed | typeof toggleAlertBadgeVisibility
>;
